import "../Loaders/style.scss";

export const Loader = () => {
  return (
    <div className="pulse-wrapper d-flex justify-content-center">
      <div className="pulse"></div>
    </div>
  );
};
